import styled from 'styled-components';

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: #eceef0;
  margin: 3.4rem 0;
`;

export const WrapperMulti = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;
